import { Sidetab } from '@typeform/embed-react';
import { Outlet, useLoaderData } from 'react-router';

import { TicketOutletContext } from '../../services/LoaderService';
import { AppView } from './AppView';

export const TicketOutlet = () => {
  const loaderData = useLoaderData() as TicketOutletContext;

  const { ticket, activeStylesheet, brandStylesheet, globalStylesheet } = loaderData;
  const serviceAppointmentId = ticket.workOrder.appointment.id;
  const feedbackSidetabId = activeStylesheet.settings.feedbackSidetab?.id;

  return (
    <>
      <AppView
        brandStylesheet={brandStylesheet}
        errorMode={false}
        globalStylesheet={globalStylesheet}
        ticket={ticket}
      >
        <Outlet context={loaderData} />
      </AppView>
      {!!feedbackSidetabId && (
        <Sidetab
          autoClose
          buttonText="Feedback"
          hidden={{
            service_appointment_id: serviceAppointmentId
          }}
          id={feedbackSidetabId}
          width={320}
        />
      )}
    </>
  );
};
